<template>
  <v-carousel
    cycle
    hide-delimiter-background
    show-arrows-on-hover
    :show-arrows="carousel && carousel.length > 1"
    :hide-delimiters="!carousel || carousel.length <= 1"
    class="px-5"
    height="500"
  >
    <template v-if="loading">
      <v-card
        style="opacity: 0.7;"
        height="500"
      >
        <v-card-text
          style="width: 100%; height: 100%;"
          class="d-flex justify-center align-center"
        >
          <v-btn
            id="carouselLoading"
            :ripple="false"
            loading
            x-large
            text
            color="white"
          />
        </v-card-text>
      </v-card>
    </template>
    <template v-else-if="carousel && carousel.length">
      <v-carousel-item
        v-for="(slide, i) in carousel"
        :key="i"
        :src="slide.image"
      >
        <v-container
          fill-height
          fluid
          class="px-12"
        >
          <v-row
            align="center"
            justify="center"
            class="px-3"
          >
            <v-container
              class="white--text"
              :class="{
                'text-left': slide.justify === 'start',
                'text-center': slide.justify === 'center',
                'text-right': slide.justify === 'end',
              }"
            >
              <v-row
                v-if="slide.title"
                :justify="slide.justify"
              >
                <v-col
                  cols="12"
                  sm="10"
                  md="8"
                  lg="6"
                  class="display-1"
                  style="text-shadow: #000 1px 1px 10px;"
                >
                  {{ slide.title }}
                </v-col>
              </v-row>

              <v-row
                v-if="slide.body"
                :justify="slide.justify"
              >
                <v-col
                  cols="12"
                  sm="10"
                  md="8"
                  lg="6"
                  class="headline"
                  style="text-shadow: #000 1px 1px 10px;"
                >
                  {{ slide.body }}
                </v-col>
              </v-row>

              <v-row
                v-if="slide.btn_text && slide.btn_cta"
                :justify="slide.justify"
              >
                <v-btn
                  color="primary lighten-2"
                  x-large
                  @click="goToAddress(slide.btn_cta)"
                >
                  {{ slide.btn_text }}
                </v-btn>
              </v-row>
            </v-container>
          </v-row>
        </v-container>
      </v-carousel-item>
    </template>
    <template v-else>
      <v-carousel-item
        v-for="(slide, i) in slides"
        :key="i"
        :src="slide.image"
      >
        <v-container
          fill-height
          fluid
          class="px-12"
        >
          <v-row
            align="center"
            justify="center"
            class="px-3"
          >
            <v-container
              class="white--text"
              :class="{
                'text-left': slide.justify === 'start',
                'text-center': slide.justify === 'center',
                'text-right': slide.justify === 'end',
              }"
            >
              <v-row
                v-if="slide.title"
                :justify="slide.justify"
              >
                <v-col
                  cols="12"
                  sm="10"
                  md="8"
                  lg="6"
                  class="display-1"
                  style="text-shadow: #000 1px 1px 10px;"
                >
                  {{ slide.title }}
                </v-col>
              </v-row>

              <v-row
                v-if="slide.body"
                :justify="slide.justify"
              >
                <v-col
                  cols="12"
                  sm="10"
                  md="8"
                  lg="6"
                  class="headline"
                  style="text-shadow: #000 1px 1px 10px;"
                >
                  {{ slide.body }}
                </v-col>
              </v-row>

              <v-row
                v-if="slide.btn_text && slide.btn_cta"
                :justify="slide.justify"
              >
                <v-btn
                  color="primary lighten-2"
                  :to="{name: slide.btn_cta}"
                  x-large
                >
                  {{ slide.btn_text }}
                </v-btn>
              </v-row>
            </v-container>
          </v-row>
        </v-container>
      </v-carousel-item>
    </template>
  </v-carousel>
</template>

<script>
import serviceApi from '@/api/coach-profile/service';

export default {
  data: () => ({
    loading: false,
    carousel: [],
    slides: [
      {
        image: 'https://cdn.sccoaching.com/content/carousel/get-gla360-certified-for-free/Carousel bg image-02.jpg',
        title: 'Use the Global Leadership Assessment',
        body: 'Become the go-to coach by offering only the best leadership tools.',
        btn_text: 'Show me options',
        btn_cta: 'assessment',
        justify: 'start',
      },
      // {
      //   image: 'https://cdn.sccoaching.com/content/carousel/use-the-global
      //   -leadership-assessment/Carousel bg image-03.jpg',
      //   title: 'Connect to us on LinkedIn',
      //   body: 'One of the easiest ways to affiliate more with the Marshall
      //   Goldsmith brand is to share the same voice. Like and share posts about
      //   Marshall Goldsmith on your own page and tag other coaches as well.',
      //   btn_text: 'Accelerate my business',
      //   btn_cta: 'assessment',
      //   justify: 'center',
      // },
      // {
      //   image: 'https://cdn.sccoaching.com/content/carousel/connect-to-us-on-linkedin/Carousel
      //   bg image-05.jpg',
      //   title: 'Use the Global Leadership Assessment',
      //   body: 'Earn your certificate in Marshall Goldsmith\'s 360 assessment
      //   (free for certified coaches). You can invite up to 2 other friends by sharing the link.',
      //   btn_text: 'Get GLA360 Certified for Free',
      //   btn_cta: 'assessment',
      //   justify: 'end',
      // },
    ],
  }),

  created() {
    this.getCarousel();
  },

  methods: {
    async getCarousel() {
      try {
        this.loading = true;
        this.carousel = await serviceApi.getCarousel();
      } catch (err) {
        console.log(err);
        if (err.msg) { this.$toast.error(err.msg); }
      } finally {
        this.loading = false;
      }
    },

    goToAddress(cta) {
      // Go outside version
      window.open(cta, '_blank');
    },
  },
};
</script>

<style lang="scss">
  #carouselLoading {
    .v-btn__loader {
      .v-progress-circular {
        width: 45px !important;
        height: 45px !important;
      }
    }
  }
</style>
